import React from 'react';
import PropTypes from 'prop-types';
import './TermsAndConditions.css';

const TermsAndConditions = ({ 
    isOpen, 
    isAnimating, 
    onAccept, 
    onDecline, 
    onClose 
}) => {
    if (!isOpen) return null;

    return (
        <>
            <button 
                className="terms-popup-overlay" 
                onClick={onClose}
                onKeyDown={(e) => e.key === 'Escape' && onClose()}
                aria-label="Close terms popup"
                // style={{ background: 'none', border: 'none', padding: 0 }}
            />
            <div 
                className="terms-popup"
                style={{
                    right: isAnimating ? '20%' : '-100%',
                }}
            >
                <h3 className="terms-title">Terms and Conditions</h3>
                <div className="terms-content">
                    <div className="terms-scrollable">
                        <h4 className="terms-subtitle">1. Payment Processing</h4>
                        <p className="terms-text">Dyrect ("the Platform") utilizes Stripe, Inc. and its affiliates ("Stripe") as a third-party service provider to process payments made through the Platform. By making or receiving payments via Dyrect, you agree to be bound by:</p>
                        <ul>
                            <li className="terms-text">Stripe Services Agreement: <a href="https://stripe.com/legal" target="_blank" rel="noopener noreferrer">https://stripe.com/legal</a></li>
                            <li className="terms-text">Stripe Connected Account Agreement (if applicable): <a href="https://stripe.com/connect-account/legal" target="_blank" rel="noopener noreferrer">https://stripe.com/connect-account/legal</a></li>
                            <li className="terms-text">Stripe Privacy Policy: <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">https://stripe.com/privacy</a></li>
                        </ul>
                        <p className="terms-text">These agreements govern all aspects of payment processing, including but not limited to the collection, storage, and security of your financial data.</p>
                        
                        <h4 className="terms-subtitle">2. Responsibility for Transactions</h4>
                        <p className="terms-text">All payment-related information, including bank account details, credit/debit card information, and transaction records, is processed and stored exclusively by Stripe. Dyrect does not collect, store, or have access to any sensitive financial data provided during payment processing.</p>
                        <p className="terms-text">Dyrect is not responsible for:</p>
                        <ul>
                            <li className="terms-text">The security of payment data entered into Stripe's systems</li>
                            <li className="terms-text">Delays, errors, chargebacks, failed transactions, or unauthorized transactions</li>
                            <li className="terms-text">Any disputes between users and their financial institutions</li>
                        </ul>

                        <h4 className="terms-subtitle">3. Limitation of Liability</h4>
                        <p className="terms-text">To the maximum extent permitted by law:</p>
                        <ul>
                            <li className="terms-text">Dyrect disclaims all liability for losses, damages, or claims arising from or related to payment transactions, including fraud, service interruptions, or technical errors in Stripe's services.</li>
                            <li className="terms-text">All liability for payment processing lies solely with Stripe as the payment processor.</li>
                        </ul>

                        <h4 className="terms-subtitle">4. User Acknowledgment</h4>
                        <p className="terms-text">By using Dyrect to facilitate payments:</p>
                        <ul>
                            <li className="terms-text">You acknowledge that Dyrect acts solely as a platform facilitator and does not provide banking, money transmission, or payment services.</li>
                            <li className="terms-text">You agree that any claims, disputes, or issues related to payments must be directed to Stripe and not Dyrect.</li>
                            <li className="terms-text">You agree to indemnify and hold harmless Dyrect, its affiliates, officers, and employees from any claims, damages, or liabilities arising out of or related to payment transactions processed through Stripe.</li>
                        </ul>

                        <h4 className="terms-subtitle">5. Changes to Payment Terms</h4>
                        <p className="terms-text">Dyrect reserves the right to update or modify these terms at any time. Continued use of the Platform for payments constitutes your acceptance of the updated terms.</p>
                    </div>
                    <div className="terms-buttons">
                        <button className="terms-cancel-btn" onClick={onDecline}>
                            Decline
                        </button>
                        <button className="terms-agree-btn" onClick={onAccept}>
                            Accept
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

TermsAndConditions.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    isAnimating: PropTypes.bool.isRequired,
    onAccept: PropTypes.func.isRequired,
    onDecline: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default TermsAndConditions;
